import { render, staticRenderFns } from "./RemoveAdmin.vue?vue&type=template&id=6a393c8d&"
import script from "./RemoveAdmin.vue?vue&type=script&lang=js&"
export * from "./RemoveAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAdmin.vue?vue&type=style&index=0&id=6a393c8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports